const LOVES_LIST = 'Loves';
const LOVES_LIST_MAX = 1000;
const OTHER_LIST_MAX = 100;
const MAX_CUSTOM_LISTS = 10;
const COPY_LINK_TIMEOUT = 2000;
const LOVES_URL = '/profile/Lists';
const PRODUCT_CARD_WIDTH = ['295px', null, '408px'];
const MAX_ONLY_A_FEW_LEFT_IN_LOVES_LIST_FLYOUT = 5;
const MAX_FLYOUT_RECENT_ITEMS = 5;
const RECENT_ITEMS_PAGINATION_SIZE = 60;
const MAX_LIMITED_LOVE_ITEMS_MY_LISTS_HOME_PAGE = 10;
const MIN_ITEMS_PER_PAGE = 4;
const MAX_ITEMS_PER_PAGE = 100;
const GENERIC_FETCHING_ERROR = 'Failed to fetch';
const ERROR_CODES = {
    GENERAL_ERROR: -1,
    DUPLICATE_ITEM: -4
};
const REPLACING_ITEMS_ERROR_CODES = {
    [ERROR_CODES.GENERAL_ERROR]: 'changesNotSaved',
    [ERROR_CODES.DUPLICATE_ITEM]: 'duplicateItem'
};

export {
    LOVES_LIST,
    LOVES_LIST_MAX,
    OTHER_LIST_MAX,
    MAX_CUSTOM_LISTS,
    COPY_LINK_TIMEOUT,
    LOVES_URL,
    PRODUCT_CARD_WIDTH,
    MAX_ONLY_A_FEW_LEFT_IN_LOVES_LIST_FLYOUT,
    MAX_FLYOUT_RECENT_ITEMS,
    RECENT_ITEMS_PAGINATION_SIZE,
    MAX_LIMITED_LOVE_ITEMS_MY_LISTS_HOME_PAGE,
    MIN_ITEMS_PER_PAGE,
    MAX_ITEMS_PER_PAGE,
    GENERIC_FETCHING_ERROR,
    REPLACING_ITEMS_ERROR_CODES,
    ERROR_CODES
};
